import React from 'react';
import PropTypes from 'prop-types';
import Entry from '../Entry';
import styles from './styles.module.styl';

const TITLES = {
  spa: 'Single-Page Application (SPA) SDK Libraries',
  webapp: 'Regular Web Application SDK Libraries',
  backend: 'Backend Service and API SDK Libraries',
  native: 'Native and Mobile Application SDK Libraries',
  mgmt: 'Management API SDK Libraries',
  lock: 'Lock SDK Libraries',
};

const DESCRIPTIONS = {
  spa: 'Need to protect a JavaScript application that runs entirely in a browser? Choose your technology below.  ',
  webapp:
    'Have a traditional web application that runs on a server? Auth0 maintains these SDK libraries for the most popular languages and environments. ',
  backend: 'Does your API or service need authentication? Auth0 has SDKs for common API and service development tools.',
  native:
    'Developing  mobile or desktop applications that run natively on a user’s device? Choose from one of these SDKs to get started.',
  mgmt: 'Need to programmatically perform Auth0 administrative tasks? Choose from one of these management libraries.',
  lock: "Do you use Lock, Auth0's legacy self-hosted login experience? You can still rely on these libraries for self-hosted login.",
};

const Category = (props) => {
  const { name, sdks } = props;
  if (!sdks.length) return <></>;

  return (
    <section className={styles.categoryHeader}>
      <h2 id={name}>{TITLES[name]}</h2>
      <p>{DESCRIPTIONS[name]}</p>
      <ul>
        {sdks.map((sdk) => (
          <Entry {...sdk} />
        ))}
      </ul>
    </section>
  );
};

Category.propTypes = {
  name: PropTypes.string,
  sdks: PropTypes.array,
};

Category.defaultProps = {
  sdks: [],
};

export default Category;
